import React from "react"
import { Link } from "react-router-dom"
import "../../assets/css/common.css"
import { t } from '../../components/i18n/i18n'
import { usePageLocale } from '../../components/i18n/usePageLocale'
import back from "../../assets/images/elements/aboutHeader.jpg";
import article_img from "../../assets/images/articles/10_full.jpeg"
import articlePdf from "../../resources/10-enduring-life.pdf";

export const Article10EnduringLife = () => {
    const ready = usePageLocale('article10');
    if (!ready) return <div style={{ padding: '60px', textAlign: 'center', color: '#999' }}>•••</div>;
    return (

        <section className='text_container_light'>
            <div className='container_100'>
                <div className='backImg15'>
                    <img src={back} alt='' />
                    <div className='text_container_dark_15'>
                        <div className='h1_15'>{t("resourceArticle10Title")}</div>
                    </div>
                </div>

                <br />

                <div className='container boxItems'>
                    <Link to='/resources' style={{textDecoration: 'none', color: '#777'}}>
                        {t("resourceBackToList")}
                    </Link>
                    <br /><br />

                    <div className='article_grid'>
                        {/* ЛІВА КОЛОНКА */}
                        <div>
                            <h2 className='menuColor'>{t("resourceArticle10Title")}</h2>

                            <p>{t("resourceArticle10Author")}</p>
                            <div style={{ marginTop: '10px' }}>
                                <a
                                    href={articlePdf}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="pdf-download-link"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        color: '#b22222',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}
                                >
                                    <span style={{ marginRight: '8px' }}>📄</span>
                                    {t("resourceArticleDownloadOriginal")}
                                </a>
                            </div>

                            <hr />
                            <br/>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P4") }} /></p>

                            <h3 className='menuColor'>{t("resourceArticle10Sec1")}</h3>

                            <img
                                src={article_img}
                                alt={t("resourceArticle10Title")}
                                className="article-img"
                            />

                            <br />
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P5") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P6") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P7") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P8") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P9") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P10") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P11") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P12") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P13") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P14") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P15") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P16") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P17") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P18") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P19") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P20") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P21") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P22") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P23") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P24") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P25") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P26") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P27") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P28") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P29") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P30") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P31") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P32") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P33") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P34") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P35") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P36") }} /></p>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P37") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P38") }} /></p>

                            <h3 className='menuColor'>{t("resourceArticle10Sec2")}</h3>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P39") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P40") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P41") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P42") }} /></p>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P43") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P44") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P45") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P46") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P47") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P48") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P49") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P50") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P51") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P52") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P53") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P54") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P55") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P56") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P57") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P58") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P59") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P60") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P61") }} /></p>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P62") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P63") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10P64") }} /></p>

                            <br/>
                            <hr />

                        </div>

                        {/* ПРАВА КОЛОНКА */}
                        <div>
                            <br/>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10ConfessionsIntro") }} /></p>

                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10CE1") }} /></p>
                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10CE2") }} /></p>
                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10CE3") }} /></p>
                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10CE4") }} /></p>
                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10CE5") }} /></p>
                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10CE6") }} /></p>
                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10CE7") }} /></p>
                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10CE8") }} /></p>
                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10CE9") }} /></p>
                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10CE10") }} /></p>
                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10CE11") }} /></p>
                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10CE12") }} /></p>
                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle10CE13") }} /></p>

                            <br/>
                            <hr />
                            <p style={{ fontSize: '13px', color: '#999', marginTop: '10px' }}>
                                {t("resourceArticle10ConfessionsNote")}
                            </p>
                            <p style={{ fontSize: '13px', color: '#999' }}>
                                {t("resourceArticle10Copyright")}
                            </p>
                            <br/>

                        </div>
                    </div>
                </div>
                <br />
            </div>
        </section>
    )
}
